import React from "react";
import Seo from "../components/Seo";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="max-w-4xl mx-auto px-6 py-24">
      <Seo
        title="Manifesto"
        description="Let go. Let's grow. The manifesto behind KaiyaYoga — art-driven yoga towels that turn your surroundings into inspiration."
        path="/about"
      />
      <div className="label-eyebrow mb-3">The manifesto</div>
      <h1 className="font-serif-display text-4xl md:text-5xl leading-[0.95] mb-16">
        let go.<br />
        <span style={{ color: "var(--kaiya-primary)" }}>let&apos;s grow.</span>
      </h1>

      <div className="space-y-8 text-lg md:text-xl leading-relaxed">
        <p>
          At <strong>KaiyaYoga</strong>, we believe your <strong>surroundings have the power to inspire</strong> your growth and possibilities.
        </p>
        <p>
          By blending art and intention, we partner with <strong>female artists</strong> to elevate your space, <em style={{ color: "var(--kaiya-primary)" }}>sparking your own creative expression</em>.
        </p>
        <p>
          KaiyaYoga is more than a brand — it&apos;s an invitation to <strong>release what no longer serves you</strong> and embrace what fuels your growth, on and off the mat.
        </p>
      </div>
    </div>
  );
}
